module.exports = __webpack_public_path__ + "media/images/bnr_affiliate_menu-5132388a6c80246e153b85533e31426b.jpg";